//my imports
import { AgGridReact, AgGridReactProps, CustomCellRendererProps } from "ag-grid-react";
import { GridReadyEvent, GridSizeChangedEvent, themeQuartz, ValueFormatterParams } from "ag-grid-community"
import { ColDef, ColDefField } from "ag-grid-community";

//module registry
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community"; 
import { DateTimeFormatter, Instant, ZoneId, ZoneOffset } from "@js-joda/core";
import { useRef } from "react";
import { Card } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";
ModuleRegistry.registerModules([AllCommunityModule]);

export function colText<T>( field: ColDefField<T, string> ): ColDef<T> {
    return {
        field: field
    };
}

export function colNumber<T>( field: ColDefField<T, number> ): ColDef<T> {
    return {
        field: field,
        type:  "rightAligned"
    };
}

export function colDegrees<T>( field: ColDefField<T, number> ): ColDef<T> {
    return {
        field:        field,
        type:         "rightAligned",
        cellRenderer: ( props: CustomCellRendererProps) => {
            return <>{ props.valueFormatted }&deg;</>
        }
    }
}

export function colInstantFmt<T>( field: ColDefField<T, Instant>, fmt: DateTimeFormatter ): ColDef<T> {
    return {
        field: field,
        valueFormatter: ( params ) => {
            const val   = (params.value as Instant)!;
            const zoned = val.atZone( ZoneId.UTC );
            return zoned.format( fmt );
        }
    }
}

export const IsoDateUtc       = DateTimeFormatter.ofPattern( "uuuu-MM-dd" );
export const IsoTimeMillisUtc = DateTimeFormatter.ofPattern( "HH:mm:ss.SSS" );

export function DataGrid( props: AgGridReactProps ) {
    const gridRef = useRef<AgGridReact>( null );

    function handleDownload() {
        gridRef.current!.api.exportDataAsCsv( { allColumns: true } );
    }

    function onGridReady( params: GridReadyEvent ): void {
        params.api.sizeColumnsToFit();
    }
    function onGridSizeChanged( params: GridSizeChangedEvent ): void {
        params.api.sizeColumnsToFit();
    }

    return <div className="h-100 rounded-0 border" style={{ display: "grid", gridTemplateRows: "auto 1fr" }}>
        <Card className="rounded-0 border-0">
            <Card.Header>
                <Download style={{ cursor: "pointer" }} onClick={handleDownload} /> Download as CSV
            </Card.Header>
        </Card>
        <AgGridReact
            ref={gridRef}
            animateRows={ false }
            theme={themeQuartz.withParams( {
                 wrapperBorderRadius: "0px 0px 0px 0px",
                 wrapperBorder:       false
            })}
            autoSizeStrategy={ { type: "fitGridWidth" } }
            onGridReady={onGridReady}
            onGridSizeChanged={onGridSizeChanged}
            {...props} />
    </div>
}

